<template>
  <div class="menu">
    <el-collapse v-model="collapse" accordion>
      <el-collapse-item
        :name="menu.title"
        v-for="(menu, index) in menus"
        :key="index"
      >
        <template slot="title">
          <div
            class="menu-title"
            :class="{ active: menuActive === menu.title }"
          >
            {{ menu.title }}
          </div>
        </template>
        <div
          v-for="child in menu.child"
          :key="child.pathName"
          class="menu-path pointer"
          :class="{ active: activePath === child.pathName }"
          @click="selectMenu(child.pathName)"
        >
          {{ child.title }}
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { userIsCustomer } from "@/api/userCenter";
import {
  UserCenter,
  MallManage,
  LabManage,
  // ExpertCentr,
  // EnterpriseCenter,
} from "@/constant/userAuth";
export default {
  props: {
    pathName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      collapse: "",
      menuActive: "",
      activePath: "",
      menus: [UserCenter],
    };
  },
  computed: {
    ...mapGetters(["userBaseInfo"]),
  },
  watch: {
    pathName(newVal) {
      this.setCollapseActive(newVal);
    },
  },
  created() {
    this.filterAuths();
    // 判断用户是否为客服
    // this.judgeUserIsCustomer();
    this.setCollapseActive();
  },
  methods: {
    // 判断用户是否为客服
    async judgeUserIsCustomer() {
      const res = await this.$axios.get(userIsCustomer);
      if (res) {
        this.menus[0].child.push({ title: "咨询中心", pathName: "chartroom" });
      }
    },
    // 菜单权限过滤
    async filterAuths() {
      if (!this.userBaseInfo.userId) {
        await this.$store.dispatch("GetUserBaseInfo");
      }
      const {
        isCheckmall,
        isLaboratory,
        // isExpert,
        // isBusiness
      } = this.userBaseInfo;
      const isPass = "1"; // 审核通过
      if (isCheckmall === isPass) {
        this.menus.push(MallManage);
      }
      if (isLaboratory === isPass) {
        this.menus.push(LabManage);
      }
      // if (isExpert) {
      //   this.menus.push(ExpertCentr);
      // }
      // if (isBusiness) {
      //   this.menus.push(EnterpriseCenter);
      // }
    },
    selectMenu(pathName) {
      if (this.$route.name !== pathName) {
        this.$router.push({ name: pathName });
      }
    },
    setCollapseActive(pathName = this.$route.name) {
      this.activePath = pathName;
      const menu = this.menus.find((item) => {
        const child = item.child.find((child) => child.pathName === pathName);
        return child;
      });
      this.collapse = menu.title;
      this.menuActive = menu.title;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.menu {
  height: 100%;
  /deep/ .el-collapse {
    border: none;
  }
  /deep/ .el-collapse-item__header {
    background: #f2f7ff;
    border: none;
    &:hover {
      background: #e3ecff;
    }
  }
  /deep/ .el-collapse-item__content {
    padding-bottom: 0;
  }
  &-title {
    font-size: 14px;
    color: #666666;
    padding-left: 23px;
    &.active {
      color: #4482ff;
      font-weight: bold;
    }
  }
  &-path {
    height: 46px;
    line-height: 46px;
    background: #f2f7ff;
    padding-left: 47px;
    border-left: 3px solid #f2f7ff;
    &:hover {
      background: #e3ecff;
    }
    &.active {
      background: #e3ecff;
      color: #4482ff;
      border-left: 3px solid #4482ff;
    }
  }
}
</style>
